import React from 'react';
import {Route, Routes} from 'react-router-dom';
import {ROUTES} from '@/config/routesConstants';
import CreatorCrm from '@/views/creators/creator-crm';
import OffPlatformProfile from '@/views/creators/creator-crm/off-platform-profile';
import Profile from '@/views/creators/profile/Profile';
import SpinningLoader from '@/components/spinning-loader';

export const CREATOR_CRM_ROUTES = {
  MAIN: '',
  OFF_PLATFORM_PROFILE: 'off-platform/:offPlatformCreatorId',
  CREATOR_PROFILE: `${ROUTES.CREATOR_PROFILE}/:creatorId`,
};

function CreatorCrmRoutes() {
  return (
    <Routes>
      <Route path={CREATOR_CRM_ROUTES.MAIN} element={<CreatorCrm />} />
      <Route
        path={CREATOR_CRM_ROUTES.OFF_PLATFORM_PROFILE}
        element={
          <OffPlatformProfile
            customLoader={
              <SpinningLoader color="black" containerHeight="100%" />
            }
          />
        }
      />
      <Route
        path={CREATOR_CRM_ROUTES.CREATOR_PROFILE}
        element={
          <Profile
            customLoader={
              <SpinningLoader color="black" containerHeight="100%" />
            }
          />
        }
      />
    </Routes>
  );
}

export default CreatorCrmRoutes;
